import { render, staticRenderFns } from "./Supplycategories.vue?vue&type=template&id=4410ef7a"
import script from "./Supplycategories.vue?vue&type=script&lang=js"
export * from "./Supplycategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports